<template>
    <!-- <main id="body" pow-style="width: 100|vw; height: 100|vh;">
        <h1 class="main-title" pow-style="theme(c): bright;">حوزه علمیه مشکات</h1>
        <a href="#main_content" id="watch_content" pow-style="theme(fs): text;">ادامه مطالب...</a>
    </main>
    <article id="scrollable_content" pow-style="theme(fs): text;" :style="{ top: $route.path == '/' ? '100vh' : 0 }">
        <router-view></router-view>

        <Footer />
    </article>

    <Navbar /> -->

    <div class="header-slider">
        <Navbar />
        <router-view></router-view>
    </div>
    <Footer />
    <BackToTop />
</template>

<script setup>

import { ref, watch, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/authentication'

import Navbar from '@/components/Navbar'
import Footer from '@/components/Footer'
import BackToTop from '@/components/BackToTop'

import $ from 'jquery'
import prototype from './prototype'


const $route = useRoute()
const auth = useAuth()

</script>

<style lang="less">

    @font-face {
        font-family: Doran;
        src: url('@/assets/Doran-Regular.woff2') format(woff2);
        font-weight: normal;
    }

    @font-face {
        font-family: Doran;
        src: url('@/assets/Doran-ExtraBold.woff2') format(woff2);
        font-weight: bold;
    }

    @font-face {
        font-family: B Lotus;
        src: url('@/assets/BLotus.ttf') format(truetype);
        font-weight: normal;
    }

    @font-face {
        font-family: B Lotus;
        src: url('@/assets/BLotusBd.ttf') format(truetype);
        font-weight: bold;
    }

    * {
        outline: none !important;
        font-family: Doran, "Segoe UI", Calibri, Arial, sans-serif, system-ui;
        text-decoration: none !important;
    }

    html,
    body {
        width: 100vw;
        min-height: 100vh;
        margin: 0;
        padding: 0;
        overflow-x: hidden;
        overflow-y: auto;
    }

    ::-webkit-scrollbar {
        width: .6vw;
        background-color: #dcdcdc;
        border-radius: 15px;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0 -1px 13px #dcdcdc;
        border-radius: 15px;
    }

    ::-webkit-scrollbar-thumb {
        background: #21b198;
        cursor: pointer;
        border-radius: 15px;
        transition: all .2s ease-in-out;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #3dc9b1;
    }

    //////////////////////////////////////////////////////////////////////////

    .container {
        margin: 0 auto;
        width: 90%;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .slider img {
        width: 100%;
        height: 750px;
        object-fit: cover;
        margin-bottom: 2px;
    }

    .slid-cat {
        height: 551px;
    }

    .slid-cat img {
        width: 100%;
        height: 550px;
        object-fit: cover;
        margin-bottom: 2px;
    }

    .diwider-tape {
        width: 100%;
        display: flex;
        height: 70px;
    }

    .brown-tape {
        width: 21%;
        background: #8a5f2e;
    }

    .gray-tape {
        width: 2%;
        background: #dcdcdc;
    }

    .green-tape {
        width: 77%;
        background: linear-gradient(90deg, rgba(32, 159, 137, 1) 0%, rgba(83, 228, 203, 1) 28%, rgba(32, 159, 137, 1) 100%);
    }

    .about-mesh {
        height: auto;
        width: 90%;
        margin: 60px auto;
        display: flex;
        position: relative;
        justify-content: center;
    }

    .video-box {
        display: flex;
        justify-content: space-between;
        margin-left: 10px;
    }

    .video-place {
        width: 480px;
        height: 270px;
        background: #000;
        margin: auto;
    }

    .video-list {
        width: 101px;
        height: 300px;
        overflow-y: scroll;
        padding-left: 15px;
        margin: auto 20px;
    }

    .video-list img {
        width: 90px;
        height: 90px;
        margin: 0px auto;
        object-fit: cover;
        border: 1px solid #eee;
        border-radius: 10px;
    }

    ::-webkit-scrollbar {
        width: .6vw;
        background-color: #dcdcdc;
        border-radius: 15px;
    }

    ::-webkit-scrollbar-thumb {
        background: #21b198;
        cursor: pointer;
        border-radius: 15px;
        transition: all.2s;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #3dc9b1;
    }

    ::-webkit-scrollbar-track {
        box-shadow: inset 0px -1px 13px #dcdcdc;
        border-radius: 15px;
    }

    .comment {
        max-width: 480px;
        margin: auto 0;
    }

    .comment h2 {
        color: #209f89;
        font-size: 160%;
        margin: 0;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
    }

    .comment p {
        text-align: justify;
        font-size: 90%;
        color: #333;
        margin: 10px auto;
    }

    .news-box {
        width: 100%;
        background: #eaeaea;
        text-align: center;
    }

    .bameshkatiha {
        width: 100%;
        height: auto;
        text-align: center;
    }

    span.title {
        color: #209f89;
        font-size: 36px;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
        text-align: center;
        margin: 50px auto;
        display: inline-block;
    }

    .news,
    .meshkati {
        width: 95%;
        margin: 0 auto;
        text-align: right;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .news-top,
    .meshkati-top {
        width: 600px;
        height: 300px;
        object-fit: cover;
        border: 1px solid #c8c8c8;
        border-radius: 10px;
        overflow: hidden;
        margin: 0 0 20px 5px;
        position: relative;
        display: flex;
        flex-flow: column nowrap;
        align-items: center;
    }

    .news-top-back {
        background: linear-gradient(0deg, rgb(39, 39, 39) 4%, rgba(39, 39, 39, 0.6502801804315477) 59%, rgba(39, 39, 39, 0) 94%);
        position: absolute;
        bottom: 0;
        padding-bottom: 20px;
        width: 100%;
        z-index: 1;
    }

    .news-top-back a {
        color: #efefef;
        text-decoration: none;
        font-size: 130%;
        text-align: right;
        margin: auto 10px;
        text-shadow: 0px -5px 9px rgba(0, 0, 0, 0.8);
        font-weight: bold;
        display: block;
        transition: all .2s
    }

    .news-top-back a:hover {
        color: #3fe6ca;
    }

    .news-top-back h3 {
        font-size: 14px;
        color: #eee;
        font-weight: normal;
        margin: auto;
        padding: 0 10px;
        text-shadow: 0px -5px 9px rgba(0, 0, 0, 0.8);
    }

    .news-top-back h4 {
        font-size: 10px;
        font-weight: normal;
        color: rgb(140, 140, 140);
        margin: 10px;
    }

    .news-top img,
    .meshkati-top img {
        min-width: 100%;
        min-height: 100%;
        object-fit: cover;
        transition: all .2s;
    }

    .news-top:hover img,
    .meshkati-top:hover img {
        transform: scale(1.1);
        cursor: pointer;
    }

    .news-post-1,
    .meshkati-post-1 {
        width: 300px;
        height: 300px;
        object-fit: cover;
        border: 1px solid #dddddd;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 5px;
        background: #f4f4f4;
        transition: all .2s;
        margin-bottom: 20px;
    }

    .news-post-1:hover,
    .meshkati-post-1:hover {
        margin-top: -2px;
        border: 1px solid rgb(32, 159, 137);
        border-radius: 15px;
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.19);
        cursor: pointer
    }

    .news-post-1 img,
    .meshkati-post-1 img {
        width: 100%;
        height: 170px;
        object-fit: cover;
    }

    .news-post-1 h3,
    .meshkati-post-1 h3 {
        font-size: 14px;
        color: rgb(140, 140, 140);
        line-height: normal;
        font-weight: normal;
        margin: 5px 10px 0 0;
    }

    .news-post-1 h2,
    .meshkati-post-1 h2 {
        font-size: 100%;
        color: rgb(138, 95, 46);
        font-weight: bold;
        line-height: normal;
        margin: 5px 10px 0;
    }

    .news-post-1 h4,
    .meshkati-post-1 h4 {
        font-size: 10px;
        font-weight: normal;
        color: rgb(140, 140, 140);
        padding: 5px 10px 0 0;
        margin-top: 5px;
    }

    .gallery-box {
        width: 100%;
        text-align: center;
        margin-top: 170px;
        display: inline-block;
        background: #ddd;
    }

    .light-box {
        width: 100%;
        background: #464646d4;
        position: absolute;
    }

    .light-box-content {
        height: 921px;
        display: inline-flex;
        justify-content: center;
    }

    .light-box-pic {
        margin: auto;
    }

    .light-box-pic img {
        width: 800px;
        border-radius: 5px;
        border: 1px #9d9d9d dashed;
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.44);
        display: block;
    }

    .light-box-pic span {
        background: #d0d0d0;
        padding: 5px 40px;
        border-radius: 10px;
        display: inline-block;
        margin-top: 10px;
    }

    .light-box-bottoms {
        margin: auto 10px;
        z-index: 1000;
    }

    .light-box-bottoms ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .light-box-bottoms a {
        color: #292929;
        width: 36px;
        height: 36px;
        background: #ddd;
        display: inline-block;
        text-decoration: none;
        font-size: 130%;
        font-weight: bold;
        border-radius: 50%;
        margin: 3px;
        border: 1px solid #99692c;
        transition: all .2s;
        text-align: center;
    }

    .light-box-bottoms a:hover {
        color: #d73b3b;
        border: 1px solid #d73b3b;
        cursor: pointer;
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.44);
    }

    .news-post-3 {
        width: 300px;
        height: 290px;
        object-fit: cover;
        border: 1px solid #dddddd;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 5px;
        background: #f4f4f4;
        transition: all .2s;
        margin-bottom: 20px;
    }

    .news-post-3:hover {
        margin-top: -2px;
        border: 1px solid rgb(32, 159, 137);
        border-radius: 15px;
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.19);
        cursor: pointer
    }

    .news-post-3 img {
        width: 100%;
        height: 170px;
        object-fit: cover;
    }

    .news-post-3 h3 {
        font-size: 14px;
        color: rgb(140, 140, 140);
        line-height: normal;
        font-weight: normal;
        margin: 10px 10px 0 0;
    }

    .news-post-3 h2 {
        font-size: 100%;
        color: rgb(123, 123, 123);
        font-weight: normal;
        line-height: normal;
        margin: 5px 10px 0;
        height: 60px;
    }

    .news-post-3 h4 {
        font-size: 10px;
        font-weight: normal;
        color: rgb(140, 140, 140);
        padding: 5px 10px;
    }

    .more {
        font-size: 26px;
        padding: 7px 35px;
        background: #8a5f2e;
        color: #fff;
        transition: all .2s;
        margin: 40px auto;
        display: inline-block;
        cursor: pointer;
        border: none;
    }

    .more:hover {
        padding: 7px 55px;
        background: #209f89;
        cursor: pointer
    }




    .amo-pjo {
        width: 100%;
        text-align: center;
        background: radial-gradient(circle, rgb(194, 131, 60) 0%, rgb(138, 95, 46) 51%);
    }

    span.title-white {
        color: #fff;
        font-size: 36px;
        border-right: 20px solid #209f89;
        padding-right: 20px;
        font-weight: bold;
        text-align: center;
        margin: 50px auto;
        display: inline-block;
    }

    .am-pj {
        width: 70%;
        margin: 0 auto;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .am-pj-post {
        width: 30%;
        margin: 1vw;
        transition: all .2s;
    }

    .am-pj-post img {
        width: 100%;
        height: 225px;
        object-fit: cover;
        border: 1px solid #dddddd;
        border-radius: 30px;
        transition: all .2s;
    }

    .am-pj-post img:hover {
        cursor: pointer;
        transform: scale(1.01);
    }

    .am-pj-post h2 {
        font-size: 100%;
        color: rgb(255 255 255);
        font-weight: bold;
        line-height: normal;
        text-align: right;
        margin: 0 25px;
        max-width: 300px;
    }

    .am-pj-post h2:hover {
        transition: all .2s;
        cursor: pointer;
        color: #3fe6ca;
    }

    .am-pj-post h3 {
        font-size: 14px;
        color: rgb(201 201 201);
        line-height: 1.714;
        font-weight: normal;
        margin: 10px 25px;
        text-align: right;
    }

    .am-pj-post h4 {
        font-size: 10px;
        font-weight: normal;
        color: rgb(70 52 32);
        margin: 10px 25px;
        text-align: right;
    }

    .more-green {
        font-size: 26px;
        padding: 7px 35px;
        background: #209f89;
        color: #fff;
        transition: all .2s;
        margin: 30px auto 70px;
        display: inline-block;
        border: none;
    }

    .more-green:hover {
        font-size: 26px;
        padding: 7px 45px;
        background: #eee;
        color: #209f89;
        cursor: pointer
    }




    .new-register-tag {
        background-color: rgb(32, 159, 137);
        margin: auto 0;
        text-align: center;
        width: 42%;
        padding: 30px;
    }

    .new-register-tag a {
        font-size: 270%;
        color: #fff;
        font-weight: bold;
        text-decoration: none;
        display: block;
        transition: all .2s;
    }

    .new-register-tag a:hover {
        color: #1e1e1e;
        text-shadow: 0px 14px 9px rgba(0, 0, 0, 0.5);
    }

    .new-register-tag span {
        font-size: 110%;
        color: #fff;
        padding: 10px;
        display: block;
    }

    .new-register {
        width: 100%;
        margin: 60px auto;
        background-color: rgb(138, 95, 46);
    }

    .new-register p {
        width: 40%;
        margin: auto;
        font-size: 110%;
        color: rgb(255, 255, 255);
        line-height: normal;
        text-align: justify;
    }

    .reg-pack {
        width: 65%;
        display: flex;
    }

    .reg-img {
        width: 35%;
        margin-top: -25px;
    }

    .new-register img {
        object-fit: cover;
        box-shadow: 0px 9px 40.94px 6px rgb(0 0 0 / 50%);
        width: 100%;
    }

    .new-register img {
        object-fit: cover;
        box-shadow: 0px 9px 40.94px 6px rgb(0 0 0 / 50%);
        display: block;
    }

    .calendar-box {
        background: linear-gradient(90deg, rgba(32, 159, 137, 1) 0%, rgba(32, 159, 137, 1) 44%, rgba(59, 213, 186, 1) 80%, rgba(32, 159, 137, 1) 100%);
        width: 100%;
        height: auto;
        padding: 40px 0;

        @media screen and (max-width: 910px) {
            background: linear-gradient(0deg, rgba(32, 159, 137, 1) 0%, rgba(32, 159, 137, 1) 44%, rgba(59, 213, 186, 1) 80%, rgba(32, 159, 137, 1) 100%);
        }
    }

    .calendar-box img {
        width: 80%;
        object-fit: cover;
        margin-top: 50px;
    }

    .calendar-pic {
        width: 40%;
        margin: auto;
    }

    .calendar-comment {
        width: 31%;
        margin: auto 2%;
    }

    .calendar-pic h2 {
        color: #2d2d2d;
        font-size: 200%;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
    }

    .calendar-comment p {
        font-size: 100%;
        color: rgb(255, 255, 255);
        line-height: normal;
        text-align: justify;
    }

    .calendar-list {
        width: 45%;
    }

    .list-item {
        overflow-y: scroll;
        height: 345px;
    }

    .list-item ul {
        list-style: none;
        padding: 0;
    }

    .list-item li {
        display: inline-block;
    }

    .myTable {
        transition: all.2s;
        width: 100%;
    }

    .myTable tr.clickable td:hover {
        border: none;
    }

    .myTable tr:nth-of-type(odd) {
        background: #3dc9b15e;
    }

    .myTable td h2 {
        margin: 0;
        font-size: 20px;
        color: #fff;
        font-weight: bold;
        line-height: 1.5;
        border-right: 15px solid #8a5f2e;
        padding-right: 10px;
        transition: border .2s ease;
    }

    .myTable td h3 {
        color: rgb(45, 45, 45);
        margin: 0;
        font-size: 10pt
    }

    .myTable td p {
        color: rgb(45, 45, 45);
        margin: 5px 0 0;
        font-size: 17px;
        font-weight: normal;
    }

    .myTable td {
        width: auto;
        padding: 20px 30px 12px 30px;
        border-bottom: 1px solid #60deae;
        display: flex;
        margin: 0 auto;
        flex-flow: row nowrap;
        justify-content: space-between;
    }

    .myTable td input {
        background: none;
        border: none;
        border-bottom: 2px solid #0003;
        font-size: inherit;
        width: 100%;
        color: inherit;
        font-weight: inherit;
    }

    .myTable .clickable td input {
        width: calc(100% - 2rem);
    }

    .myTable td p input {
        width: 50px!important;
        text-align: center;
        font-family: B Lotus, Doran, Arial, Sans-Serif;
        font-size: 130%;
        display: inline-block;

        &::-webkit-inner-spin-button, &::-webkit-outer-spin-button {
            appearance: none;
        }
    }

    .myTable td>*:first-child {
        width: 90%;
    }

    .myTable td>*:last-child { 
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        font-size: 1.4rem;
    }

    .myTable td>*:last-child button {
        background: none;
        border: none;

        &.link_button {
            background-image: url(@/assets/link.png);
            background-repeat: no-repeat;
            background-size: 1rem;
            background-position: center;
            background-clip: cover;
            height: 1rem;
        }
    }

    .myTable tr {
        transition: all.2s;
        border-radius: 10px;
    }

    .myTable tr.clickable h2::before {
        content: ' ';
        background-image: url(@/assets/link.png);
        background-repeat: no-repeat;
        background-position: center;
        background-size: 1.3rem;
        display: inline-flex;
        flex-flow: column nowrap;
        justify-content: flex-end;
        width: 1.4rem;
        height: 1.4rem;
        margin-left: .4rem;
        margin-top: 2px;
    }

    .myTable tr.clickable:hover {
        cursor: pointer;
        background: #45c0ab;
        border-radius: 10px;
        border: 1px solid #bd8342;
        display: block;

        h2 {
            border-color: #bd8342;
        }
    }

    .mesh-masajed {
        background: #eaeaea;
        width: 100%;
        height: auto;
        padding: 70px 0;
    }

    .about-masajed {
        width: 90%;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 0 auto;
    }

    .about-mas {
        width: 27%;
        margin: auto;
        border-left: 1px dashed #737373;
        padding-left: 2%;
    }

    .about-mas h2 {
        color: #209f89;
        font-size: 180%;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
    }

    .about-mas p {
        font-size: 120%;
        text-align: justify;
        color: #333333;
        margin: 0;
        line-height: normal;
    }

    .masajed {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        width: 70%;
        justify-content: center;
    }

    .masjed-01 {
        width: 19%;
        height: 270px;
        background: #f7f7f7;
        border: 1px solid #b7b7b7;
        border-radius: 10px;
        margin: .5%;
        transition: all.2s;
    }

    .masjed-01:hover {
        margin-top: 5px;
        border: 1px solid rgb(32, 159, 137);
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.19);
        cursor: pointer;
    }

    .masjed-01 img {
        width: 100%;
        height: 180px;
        object-fit: cover;
        border-radius: 10px 10px 0 0px;
    }

    .masjed-01 span {
        font-size: 100%;
        color: #333;
        display: block;
        text-align: right;
        font-weight: bold;
        padding: 10px;
    }

    .masjed-01 p {
        font-size: 12px;
        color: #999;
        padding: 5px 10px;
        margin: 0;
    }

    .info {
        width: 100%;
        text-align: center;
        padding-bottom: 70px;
    }

    .info h2 {
        color: #209f89;
        font-size: 36px;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
        text-align: center;
        margin: 50px auto 0;
        display: inline-block;
    }

    .infos {
        display: flex;
        width: 75%;
        margin: 50px auto 0;
    }

    .info-1 {
        width: 25%;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .info-1 img {
        object-fit: none;
        height: 140px;
    }

    .info-1 span {
        text-align: center;
        font-size: 30px;
        font-weight: bold;
        color: #8a5f2e;
    }

    .info-1 h3 {
        font-size: 130%;
        color: #209f89;
        margin: 0;
        font-weight: normal;
    }

    .international {
        width: 70%;
        margin: 0 auto;
        text-align: right;
        flex-wrap: wrap;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }

    .content-side {
        display: flex;
        justify-content: space-between;
    }

    .content {
        width: 67%;
        display: block;
        margin: 190px 0 95px 0;
        z-index: 1;
    }

    .post-img {
        width: 90%;
        margin: auto;
    }

    .post-img img, .post-img video {
        width: 100%;
        object-fit: cover;
        height: 450px;
        border-radius: 5px;
    }

    .breadcrumpb {
        border-bottom: 1px dashed #000;
        height: 45px;
    }

    .post-img ul {
        padding: 0;
        margin: 0;
        list-style: none;
    }

    .post-img li {
        float: right;
        margin: .5%;
    }

    .post-img li a {
        text-decoration: none;
        font-size: 80%;
        color: #6e6e6e;
        transition: all.2s;
    }

    .post-img li a:hover {
        cursor: pointer;
        text-decoration: none;
        color: #000;
    }

    .post-img h2 {
        color: #209f89;
        font-size: 200%;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
        display: inline-block;
        margin: 14px 0;
    }

    .post-img-data {
        display: flex;
        justify-content: flex-start;
    }

    .post-img-data h3 {
        font-size: 80%;
        color: #6e6e6e;
        margin: auto 10px;
        font-weight: normal;
    }

    .post-img-data img {
        width: 24px;
        height: 24px
    }

    .post-content {
        width: 90%;
        margin: 0 auto;
    }

    .meta-description {
        margin: 30px 0;
    }

    .meta-description p::before {
        content: attr(data-summary);
        font-size: 10pt;
        font-weight: 700;
        color: #8a5f2e;
        margin-left: 5px;
    }

    .meta-description p {
        margin: 0;
        padding: 15px;
        font-size: 100%;
        text-align: justify;
        color: #6d6e71a8;
        background: #fff;
        border-right: 4px solid #209f89 !important;
        border: 1px dashed #cdcdcd;
        border-right-width: 1px;
        border-right-style: solid;
        border-right-color: rgb(231, 231, 231);
        border-radius: 4px;
    }

    .post-content p {
        text-align: justify;
        line-height: 35px;
        font-size: 100%;
        color: #424242;
    }

    .post-content img {
        width: 60%;
        border-radius: 10px;
        display: block;
        margin: 10px;
    }

    .post-content h3,.post-content h4 {
        font-size: 150%;
        color: #8a5f2e;
        display: inline-flex;
    }

    .post-content h3::before,.post-content h4::before {
        content: ' ';
        background-image: url(@/assets/after.png);
        width: 32px !important;
        display: block;
        height: 35px;
        background-repeat: no-repeat;
        margin-left: 10px;
    }

    // .post-content h4 {
    //     font-size: 120%;
    //     color: #209f89;
    //     display: inline-flex;
    //     margin: 10px 45px 0 0;
    // }

    // .post-content h4::before {
    //     content: ' ';
    //     background-image: url(@/assets/before.png);
    //     width: 32px !important;
    //     display: block;
    //     height: 35px;
    //     background-repeat: no-repeat;
    //     margin-left: 10px;
    // }

    .viwe {
        margin: 0px auto;
        display: flex;
        padding: 10px;
    }

    .viwe img {
        width: 25px !important;
        height: 15px;
        margin: 6px 0;
    }

    .viwe span {
        margin: 0 10px;
        color: #c6c6c6;
        font-size: 10pt;
        font-weight: 400;
    }

    .related-box {
        width: 100%;
        background: #eaeaea;
        text-align: center;
        padding-bottom: 50px;
    }

    .news-post-2 {
        width: 400px;
        height: 225px;
        object-fit: cover;
        border: 1px solid #dddddd;
        border-radius: 10px;
        overflow: hidden;
        margin-left: 5px;
        background: #f4f4f4;
        transition: all .2s;
        margin-bottom: 20px;
    }

    .news-post-2:hover {
        margin-top: -2px;
        border: 1px solid rgb(32, 159, 137);
        border-radius: 15px;
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.19);
        cursor: pointer
    }

    .news-post-2 img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .news-post-2 h3 {
        font-size: 14px;
        color: rgb(140, 140, 140);
        line-height: normal;
        font-weight: normal;
        margin: 10px 10px 0 0;
    }

    .news-post-2 h2 {
        font-size: 100%;
        color: rgb(138, 95, 46);
        font-weight: bold;
        line-height: normal;
        margin: 5px 10px 0;
    }


    .comments {
        width: 70%;
        margin: 50px auto;
        border-top: 1px dashed #ddd;
        padding-top: 20px;
    }

    .comments span {
        color: #209f89;
        font-size: 160%;
        border-right: 20px solid #8a5f2e;
        padding-right: 20px;
        font-weight: bold;
        text-align: center;
        margin: 0px auto 10px;
        display: inline-block;
    }

    #comments {
        border-radius: 10px;
        padding: 10px;
        border: 1px solid #ddd;
        background: #f7f7f7;
        margin: 2px;
        width: 70%;
        height: 250px;
        font-family: 'Doran';
    }

    #author-com,
    #email-com {
        border-radius: 10px;
        padding: 10px;
        border: 1px solid #ddd;
        background: #f7f7f7;
        margin: 2px;
        font-size: 100%;
        font-family: 'Doran';
    }

    #author-com,
    #email-com {
        border-radius: 10px;
        padding: 10px;
        border: 1px solid #ddd;
        background: #f7f7f7;
        margin: 2px;
    }

    #submit-com:hover {
        background: -webkit-linear-gradient(right, #ffebb9, #8a5f2e);
        color: #ffffff;
        cursor: pointer;
    }

    #submit-com {
        background: #209f89;
        border-radius: 10px;
        padding: 10px;
        border: 1px solid #ddd;
        color: #eee;
        font-size: 100%;
        transition: all .2s;
        font-family: 'Doran';
    }

    .comment-data {
        display: flex;
    }

    .comment-lable {
        display: inline-grid;
        margin-left: 10px;
        width: 35%;
    }

    .sidebar {
        width: 33%;
        margin: 190px 0;
        z-index: 1;
        border-right: 1px dashed #a0a0a0;
    }

    .poster {
        margin: auto;
        width: 90%;
    }

    .poster img {
        width: 100%;
        height: 450px;
        object-fit: cover;
        border-radius: 5px;
        border: 1px solid #c8c8c8;
        padding: 5px;
        box-sizing: border-box;
    }

    .recent-post {
        margin: 20px auto;
        background: #fff;
        padding: 0 20px;
        width: 80%;
    }

    .recent-post span {
        text-align: center;
        color: #fff;
        font-size: 100%;
        font-weight: bold;
        border-radius: 5px;
        padding: 5px 2%;
        background: linear-gradient(90deg, rgba(89, 58, 94, 1) 0%, rgba(32, 159, 137, 1) 100%);
        display: flex;
        margin: 30px auto;
        justify-content: center;
        width: 80%;
    }

    .recent-post span::before,
    .recent-post span::after {
        content: ' ';
        width: 17%;
        height: 1px;
        margin: auto 10px;
        background: #eee;
    }

    .recent-post ul {
        list-style: none;
        padding: 0;
    }

    .recent-post-box:hover {
        background: -webkit-linear-gradient(right, #f2f2f2, #fff);
    }

    .recent-post-box {
        position: relative;
        height: 105px;
        border-bottom: 1px dashed #ddd;
        border-radius: 0 5px 5px 0;
        transition: all .5s !important;
    }

    .recent-post li {
        display: initial;
    }

    .recent-post-box img {
        border-radius: 50%;
        padding: 7px;
        position: absolute;
        width: 90px;
        transition: all.2s;
        cursor: pointer;
    }

    .recent-post-box img:hover {
        transform: rotate3d(3, 1, 1, -25deg);
    }

    .recent-post-box h2 {
        position: absolute;
        top: 5px;
        right: 105px;
        color: #6e6e72;
        font-size: 90%;
        font-weight: bold;
        transition: all .2s;
        cursor: pointer;
    }

    .recent-post-box h3 {
        position: absolute;
        top: 60px;
        right: 110px;
        color: #bfbfbf;
        font-size: 70%;
        font-weight: normal;
        transition: all.2s;
    }

    .recent-post-box h2:hover,
    .recent-post-box h3:hover {
        transform: rotate3d(15, 1, 1, -25deg);
    }

    .books {
        background: #209f89;
        text-align: left;
        padding: 30px 0 100px;
        width: 90%;
    }

    .books h3::before {
        content: ' ';
        background-image: url(@/assets/before.png);
        width: 32px !important;
        display: block;
        height: 35px;
        background-repeat: no-repeat;
        margin: -6px 30px 0 10px;
    }

    .books h3 {
        font-size: 120%;
        color: #ffffff;
        display: inline-flex;
        float: right;
        margin: 30px 80px 30px 0;
        transform: scale(1.3);
    }

    .books img {
        width: 90%;
        height: 130px;
        object-fit: cover;
        transition: all .2s;
        margin: 5px 0;
    }

    .books img:hover {
        border: 1px solid rgb(32, 159, 137);
        box-shadow: 0px 17px 40.94px 5.06px rgba(0, 0, 0, 0.19);
        cursor: pointer;
        box-sizing: border-box;
    }

    .address-box {
        width: 80%;
        margin: auto;
    }

    .address-box-1 {
        display: flex;
        justify-content: space-around;
        margin: 40px auto;
    }

    .address-1 {
        text-align: right;
    }

    .address-1 h2 {
        color: #209f89;
        font-size: 130%;
        border-right: 10px solid #8a5f2e;
        padding-right: 10px;
        font-weight: bold;
        display: inline-block;
    }

    .address-1 h3 {
        color: #8a5f2e;
        font-size: 100%;
        border-right: 10px solid #209f89;
        padding-right: 10px;
        font-weight: bold;
        display: inline-block;
    }

    .address-1 mark {
        background: no-repeat;
        color: #209f89;
        font-weight: bold;
    }

    .address-1 p {
        color: #3c3c3c;
        line-height: 32px;
        padding: 0;
        margin: 0;
    }

    .map img {
        display: block;
        border: 1px solid #b1b1b1;
        border-radius: 9px;
        width: 100%;
    }

    .map span {
        background: #1e9f8a;
        padding: 5px 20px;
        border-radius: 5px;
        display: inline-block;
        margin: 10px;
        color: #eee;
    }

    .h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6 {
        font-weight: bold !important;
    }

    @media only screen and (max-width:1744px){
.international {
  width: 80% !important;
}
}
@media only screen and (max-width:1526px){
.international {
  width: 90% !important;
}
.head-left {
    width: 25%!important;;
}
.am-pj {
  width: 90%!important;
}
.footer-pack {
    width: 90%!important;
}
.books {
    width:auto!important;
}
.books h3 {
    margin: 20px 30px!important;
}
.slid-cat {
    height: 451px !important;
}
.slid-cat img {
  height: 450px !important;
}
}

/*----عرض 1024پیکسل----*/


@media only screen and (max-width:1024px){

.head-left {
  width: 35% !important;
}
.slider {
  height: 521px !important;
}
.slider img {
  height: 520px !important;
}
.diwider-tape{
height:45px !important;
}
.new-register p {
    font-size: 80% !important;
}
.new-register-tag a {
    font-size: 230% !important;
}
.new-register-tag span {
  font-size: 100% !important;
  padding: 10px !important;
}
.new-register-tag {
    width: 40%  !important;
    padding: 20px !important;
}
.calendar-box {
    padding: 10px 0 !important;
}
.calendar-comment h2 {
    font-size: 140% !important;
}
.calendar-comment p {
    font-size: 80% !important;
}
.myTable td p {
    font-size: 75% !important;
}
.myTable td h2 {
    font-size: 110% !important;
}
.about-mas h2 {
    font-size: 160% !important;
}
.about-mas p {
    font-size: 100% !important;
}
.footer-abuot p {
    font-size: 90% !important;
}
.main-menu{
    display:none!important;
}
.menu-icon {
    display:block!important;
}
.post-img h2 {
    font-size: 160% !important;
}
.content, .sidebar {
    margin: 130px 0 !important;
}
.recent-post span {
    width: 100% !important;
}

.books h3 {
transform: scale(1)!important;
 margin: 20px 0px!important;
}
.books img {
    height: 70px!important;
}
.post-content img {
  width: 80%!important;
}
.viwe img {
  width: 25px!important;
}
.comments {
  width: 90% !important;;
}

}

/*----عرض 915پیکسل----*/

@media only screen and (max-width:915px){
.head-left {
    width: 45% !important;
}
.register a {
    width: 12.5vw !important;
}
.about-mesh {
    flex-wrap: wrap !important;
}
.video-box {
    margin-left:0 !important;
}
.video-place {
    width: 410px !important;
}
.video-list {
    margin: auto 20px auto 0 !important;
}
.comment {
    margin: 30px auto 0 !important;
}
.news-post-1, .meshkati-post-1 {
    width: 250px !important;
}
.new-register {
    margin: 20px auto !important;
    padding: 20px 0 !important;
}
.new-register p {
    font-size: 90% !important;
}
.reg-pack {
    width: 100% !important;
}
.reg-img {
    width: 45% !important;
    margin-top: 25px !important;
}
.calendar-pic {
    width: 60% !important;
    margin: 20px auto !important;
}
.calendar-comment {
    margin: auto 10% !important;
    border-top: 1px dashed #eee !important;
    border-bottom: 1px dashed #eee !important;
    padding: 10px 0 !important;
    width: 80% !important;
}
.calendar-list {
    width: 80% !important;
}
.am-pj-post {
    width: auto!important;
}
.about-mas {
    width: 70%!important;
    margin: 0 auto 60px!important;
    border-left: 0!important;
    padding-left: 0!important;
}
.masajed {
    width: 100% !important;
}

.footer-pack {
    display: block !important; 
}
.footer-abuot {
    width: auto!important;
    text-align: center; 
}
.footer-menu {
    display: none!important; 
}
.footer-address {
    width: auto!important; 
    text-align: center!important; 
    margin-top: 20px!important; 
}
.social-icons {
    margin: 0 auto!important;
}
.comment-data {
  display: inline-block !important;
}
.comment-lable {
  display: block !important;
}
 #comments {
    width: 90% !important;
}
.comment-lable {
  width: 100% !important;
}
.footer-about {
    width: 100%;
}
}

/*----عرض 576پیکسل----*/

@media only screen and (max-width:576px){

.header-logo {
    width: 60%!important;
}
.header-logo img {
    width: 90%!important;
}
.head-left {
    width: 30% !important;
}
.register {
    display: none!important;
}
.pic {
    display: none!important;
}
.about-mesh {
    margin: 20px auto !important;
}
.video-place {
    width: 330px !important;
    height: 190px !important;
}
.video-list {
    display: none !important;
}
.about-mesh {
    margin: 30px auto!important;
}
.news, .meshkati {
    width: 85%!important;
}
.news-top, .meshkati-top {
    height: 270px!important;
    width: 350px !important;
}
.news-post-1, .meshkati-post-1 {
    width: 350px !important;
}
.new-register-tag {
    width: 90% !important;
    padding: 20px !important;
    margin-bottom: 20px !important;
}
.new-register p {
    width: auto!important;
}
.reg-pack {
    display:block !important;
}
.reg-img {
    width: 85% !important;
}
.calendar-pic {
    width: 80% !important;
}
.calendar-comment h2 {
    font-size: 160% !important;
}
.calendar-comment p {
    font-size: 100% !important;
}
.calendar-list {
    width: 100% !important;
}
.about-mas {
    width: 90% !important;
}
.masjed-01 {
    margin: 0 auto 20px !important;
}
.masjed-01 {
    width: 85% !important;
}
.infos {
    flex-wrap: wrap !important;
}
.info-1 {
    width: 50% !important;
}
.content-side {
  display: inline-block !important;
}
.content {
  width: 100% !important;
}
.sidebar {
    width: 100% !important;
    margin: auto !important;
}
.books img {
    height: 110px !important;
}
.breadcrumpb {
  height: 75px !important; 
}
.meta-description {
  width: 100% !important;
}
.post-content h3 {
  font-size: 120% !important;
}
 .post-content img {
    width: 100% !important;
    margin: auto !important;
  }
.post-content h4 {
  margin: auto;
}
.viwe img {
    margin: 0 !important;
}
.news-post-2 {
  width: 270px;
}

}

</style>